<span
  class="sv-string-editor"
  contenteditable="true"
  *ngIf="model.hasHtml"
  [innerHtml]="model.renderedHtml"
  (blur)="onInput($event)"
  (click)="onClick($event)"
></span>
<span
  class="sv-string-editor"
  contenteditable="true"
  *ngIf="!model.hasHtml"
  (blur)="onInput($event)"
  (click)="onClick($event)"
  >{{ model.renderedHtml }}</span
>
